import React, { useState, useEffect } from "react";
import Modal from "../modal";
import Icon from "../../Icons/general/Icon";
import { ErrorContext } from "../../utils/context/error";
import { ActualizaClave } from "../../services/user";

function KeyModal({ show, handleshow, UsuarioI, onGuardado }) 
{
  const [shows, setShow] = useState(show);
  const [habilita, setHabilita] = useState(true);
  const [clave, setClave] = useState("");
  const [validar, setValidar] = useState(false);
  const { setShowToast, setOpciones } = ErrorContext();
  const [showPassword, setShowPassword] = useState(false);
  
  //--------------------------------------------------------------------------------------------------------------------
  const handleCancel = async () => {
    handleshow(false);
  };

  //--------------------------------------------------------------------------------------------------------------------
  const handleAceptar = async() => 
    {
      setShow(false);
      handleshow(false);
      setValidar(true);
      setHabilita(true);
      const response = await ActualizaClave({clave, UsuarioId:UsuarioI});
      if (response) 
      {
        if (response.status === 200) 
         {
           onGuardado(response.data.data); 
           handleshow(false);
           setHabilita(true);
         } 
        else 
         {
           const Mensaje = response.message;
           const opc = { type: "Danger", message: Mensaje, active: true };
           setOpciones(opc);
           setShowToast(true);
           setHabilita(false);
         }
      }

    };

  //--------------------------------------------------------------------------------------------------------------------
  useEffect(() => 
    {
     
    }, []);
    
  return (
    <>
      <Modal isOpen={show} onClose={()=>handleshow(false)} title={'Cambiar Contraseña'}>
        <div className="flex lg:w-[25rem]">
          <form noValidate className="flex flex-col w-full">
            <div className="flex flex-col w-full h-full ">
              <div className="w-full">
                <label>Contraseña</label>
                  <div className="relative mt-1">

                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    onChange={(e) => setClave(e.target.value)}
                    value={clave}
                    className={`placeholder:italic h-[2.0rem] 2xl:h-[2.5rem] min-w-0 w-full p-2.5 rounded-none bg-gray-50 border border-gray-300 text-gray-900 focus:ring-0 focus:bg-white focus:outline-none focus:border-default block flex-1  text-[0.71rem] md:text-sm ${
                      validar && clave === ""
                        ? `border-red-500 focus:border-red-500 focus:red-500`
                        : ""
                      }`}
                    placeholder="Ingresa su contraseña"
                    autoComplete="off"
                  ></input>
                  <div
                  className="absolute right-3 top-2.5 text-gray-300"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <Icon
                      svg="eyes"
                      name="eyes"
                      className="w-5 h-5 text-gray-300 cursor-pointer"
                      
                    />
                  ) : (
                    <Icon
                      svg="eyesoff"
                      name="eyesoff"
                      className="w-5 h-5 text-gray-300 cursor-pointer"
                      
                    />
                  )}
                  
                </div>

              </div>
              {validar && clave === "" ? (
                <p className="text-red-500 text-[0.6rem] font-medium italic ">
                  * Campo Obligatorio.
                </p>
              ) : (
                ""
              )}
            </div>
            </div>
            <div className="flex w-full gap-4 mt-6 justify-end">
              <button name="Aceptar" className="btnprimary" onClick={handleAceptar}  type="button">Aceptar</button>
              <button name="Cancelar" className="" onClick={handleCancel} type="button">Cancelar</button>
            </div> 
          </form>   
        </div>                                 
      </Modal>
    </>
  );
}
export default KeyModal;
